/**
 * A sortable column header: the label and an arrow that shows whether the
 * table is sorted by this column, and which way. Clicking it asks the page to
 * sort by the column (or flip the order when it already does).
 */

import { ArrowDown, ArrowUp, ArrowUpDown } from 'lucide-react';

export function SortHeader({
  label,
  sortKey,
  sort,
  order,
  onSort,
  className,
}: {
  label: string;
  sortKey: string;
  /** The column the table is sorted by now. */
  sort: string;
  order: 'asc' | 'desc';
  onSort: (key: string) => void;
  className?: string;
}) {
  const active = sort === sortKey;
  const Icon = !active ? ArrowUpDown : order === 'asc' ? ArrowUp : ArrowDown;
  return (
    <th
      scope="col"
      className={`sortable${className ? ` ${className}` : ''}`}
      aria-sort={active ? (order === 'asc' ? 'ascending' : 'descending') : 'none'}
    >
      <button type="button" className="th-sort" onClick={() => onSort(sortKey)}>
        <span>{label}</span>
        <span className={`sort-icon${active ? ' is-active' : ''}`} aria-hidden="true">
          <Icon />
        </span>
      </button>
    </th>
  );
}
